import { translate, TranslateError } from 'magner';
import { request } from '~/utils/request';

interface FileUploadResponse {
  id: string,
  image: string,
  thumbnail: string,
}

export const fileUpload = (id: string, file: File, glType: string, code: string, context: string, publish?: boolean) => {
  const errorMsg = new TranslateError(translate('hubstr.common.errors.file_upload')).name;

  const fileCreate = request.custom<FileUploadResponse, File>(async ({ api, data }) => await api
    .instance
    .url('/api/file/upload')
    .formData({
      file: data,
      glType,
      glId: id,
      code,
      context,
      publish: publish ?? false,
    })
    .post()
    .json((response) => {
      const d = (response as { result: { id: string } })?.result;
      return d?.id ? { data: d } : { error: errorMsg };
    })
    .catch(() => ({
      error: errorMsg,
    })) as any);

  return fileCreate(file);
};
